import React, { useState } from "react";
import { Checkbox, Col, Space } from "antd";
import moment from "moment";
import { WarningOutlined, FileDoneOutlined, EyeOutlined, SendOutlined, CheckOutlined, DownOutlined, RightOutlined, CloseOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../Components/Items";

const colorDeEstadoRequisicion = (requisicion) => {
  if (requisicion.estado === 0) return "rojo";
  if (requisicion.estadoRecepcion === "recibidoCompleto") return "verde";
  if (requisicion.estadoRecepcion === "recibidoParcial") return "naranja";
  return "gris";
};

const textoDeEstadoRequisicion = (requisicion) => {
  if (requisicion.estado === 0) return "Cancelada";
  if (requisicion.estadoRecepcion === "recibidoCompleto") return "Recibida";
  if (requisicion.estadoRecepcion === "recibidoParcial") return "Recibido parcial";
  if (requisicion.estadoRecepcion === "sinRecibir") return "OC generada, sin recibir";
  return "Pendiente de compras";
};

const TarjetaOrdenAlmacen = ({ orden, seleccionada, onSeleccionar, onVerDetalle, onVerRequisicion, onMarcarAtendida }) => {
  const acento = orden.faltaInventario ? "#f5222d" : "#1890ff";
  const [expandidas, setExpandidas] = useState([]);
  const [ocultas, setOcultas] = useState([]);

  const toggleExpandir = (e, id) => {
    e.stopPropagation();
    setExpandidas((prev) => (prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]));
  };
  const ocultar = (e, id) => {
    e.stopPropagation();
    setOcultas((prev) => [...prev, id]);
  };

  const solicitudesVisibles = (orden.solicitudesMaterial || []).filter((s) => !ocultas.includes(s._id));

  return (
    <Col span={6} xs={24} sm={12} lg={6}>
      <div
        onDoubleClick={() => onVerDetalle(orden._id)}
        title="Doble clic para ver el detalle"
        style={{
          background: "white",
          borderRadius: 8,
          padding: 14,
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
          border: orden.faltaInventario ? "1px solid #ffccc7" : "1px solid #f0f0f0",
          cursor: "pointer",
          height: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
            marginBottom: 10,
            paddingBottom: 8,
            borderBottom: `2px solid ${acento}40`,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 26,
                height: 26,
                borderRadius: 8,
                background: `${acento}18`,
                color: acento,
              }}
            >
              {orden.faltaInventario ? <WarningOutlined /> : <FileDoneOutlined />}
            </span>
            <span style={{ fontWeight: 600, fontSize: 14, color: "#333" }}>{orden.folio}</span>
          </div>
          <Checkbox checked={seleccionada} onClick={(e) => e.stopPropagation()} onChange={() => onSeleccionar(orden._id)}>
            <span style={{ fontSize: 12, color: "#666" }}>Selec.</span>
          </Checkbox>
        </div>

        <div style={{ fontSize: 13, color: "#555", lineHeight: 1.7 }}>
          <div><b>Producción:</b> {orden.proyectoEjecucionId?.nombre || "—"}</div>
          <div><b>Origen:</b> {orden.proyectoOrigenId?.nombre || "—"}</div>
          <div><b>Fecha:</b> {moment(orden.fecha).format("DD/MM/YYYY")}</div>
          <div><b>Cantidad a producir:</b> {orden.cantidadEsperada ?? "—"}</div>
        </div>

        {solicitudesVisibles.length > 0 && (
          <Space direction="vertical" size={6} style={{ marginTop: 8, width: "100%" }}>
            {solicitudesVisibles.map((solicitud) => {
              const expandida = expandidas.includes(solicitud._id);
              return (
                <div
                  key={solicitud._id}
                  style={{ background: "#fffbe6", border: "1px solid #ffe58f", borderRadius: 6, padding: "6px 8px", fontSize: 12 }}
                >
                  <div style={{ display: "flex", alignItems: "flex-start", gap: 4 }}>
                    <span style={{ cursor: "pointer", color: "#ad8b00", marginTop: 2 }} onClick={(e) => toggleExpandir(e, solicitud._id)}>
                      {expandida ? <DownOutlined /> : <RightOutlined />}
                    </span>
                    <div style={{ flex: 1, cursor: "pointer" }} onClick={(e) => toggleExpandir(e, solicitud._id)}>
                      <SendOutlined /> Producción pide <b>{solicitud.cantidadPiezas}</b> pza. de {solicitud.matrizNombre} en {solicitud.etapaNombre}
                    </div>
                    <span style={{ cursor: "pointer", color: "#999" }} onClick={(e) => ocultar(e, solicitud._id)} title="Ocultar por ahora">
                      <CloseOutlined />
                    </span>
                  </div>

                  {expandida && (
                    <>
                      {solicitud.solicitanteNombre && (
                        <div style={{ color: "#999", marginTop: 4, paddingLeft: 18 }}>
                          {solicitud.solicitanteNombre} — {moment(solicitud.fecha).fromNow()}
                        </div>
                      )}
                      {solicitud.observaciones && (
                        <div style={{ marginTop: 4, paddingLeft: 18 }}>
                          <b>Observaciones:</b> {solicitud.observaciones}
                        </div>
                      )}
                      {solicitud.insumosExtra?.length > 0 && (
                        <div style={{ marginTop: 4, paddingLeft: 18 }}>
                          <div style={{ color: "#ad8b00", fontWeight: 600 }}>Fuera de lista:</div>
                          {solicitud.insumosExtra.map((insumo) => (
                            <div key={insumo.insumoId}>
                              {insumo.clave ? insumo.clave + " - " : ""}
                              {insumo.descripcion}: <b>{insumo.cantidad}</b> {insumo.unidad}
                            </div>
                          ))}
                        </div>
                      )}
                      <ButtonItem
                        size="small"
                        block
                        mostaza
                        icon={<CheckOutlined />}
                        style={{ marginTop: 4 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          onMarcarAtendida(orden._id, solicitud._id);
                        }}
                      >
                        Marcar atendida
                      </ButtonItem>
                    </>
                  )}
                </div>
              );
            })}
          </Space>
        )}

        {(orden.diasSinSurtir === null || orden.diasSinSurtir === undefined) && (
          <div style={{ marginTop: 8 }}>
            <ButtonItem size="small" block gris disabled>
              Sin requisitar
            </ButtonItem>
          </div>
        )}

        {orden.requisiciones?.length > 0 && (
          <Space direction="vertical" size={4} style={{ marginTop: 8, width: "100%" }}>
            {orden.requisiciones.map((requisicion) => (
              <ButtonItem
                key={requisicion.requisicionId}
                size="small"
                block
                icon={<EyeOutlined />}
                {...{ [colorDeEstadoRequisicion(requisicion)]: true }}
                onClick={(e) => {
                  e.stopPropagation();
                  onVerRequisicion(requisicion.requisicionId);
                }}
              >
                Ver Req. {requisicion.folio} — {textoDeEstadoRequisicion(requisicion)}
              </ButtonItem>
            ))}
          </Space>
        )}
      </div>
    </Col>
  );
};

export default TarjetaOrdenAlmacen;
